export enum OrientationTypes {
  Horizontal = 'horizontal',
  Vertical = 'vertical',
}
